export const FilterConstants = {
    FILTER_ARRAY_DELIMITER: '\n',
    MAX_GET_URL_LENGTH: 8000,
}
